/**
 * GET /task-templates?relations[0]=author
 */
export const TASK_TEMPLATE_RELATIONS = {
  'relations[0]': 'author',
};

export const buildTaskTemplateRelationParams = () => ({ ...TASK_TEMPLATE_RELATIONS });

export const TASK_TEMPLATE_PRIORITY_OPTIONS = ['low', 'medium', 'high'];
